<template>
<div class="row">
  <div class="col-xs-12 text-right">
    <router-button
      title="Novo"
      :to="{name: 'categories.create'}"
      icon-class="ti-plus"
      :classStyle="{ btn: true, 'btn-flat': true, 'btn-icon': false, 'btn-info': true }"
    />
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="card">
        <div class="card-content">
          <table-categories @refresh="fetch"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TableCategories from './TableCategories'
import { mapActions } from 'vuex'

export default {
  name: 'show-categories',

  components: {
    TableCategories
  },

  methods: {
    ...mapActions('categories', {
      fetchCategories: 'fetchAll'
    }),
    fetch () {
      this.fetchCategories({
        limit: 99999,
        sort: {
          field: 'createdAt',
          direction: 'desc'
        }
      })
    }
  },

  mounted () {
    this.fetch()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ConfigurationsPages/Categories/ShowCategories.vue